import { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
export type PrismicBodyTextProps = {
    content: RichTextField;
};

const PrismicBodyText = ({ content }: PrismicBodyTextProps) => {
    return (
        <PrismicRichText
            field={content}
            components={{
                paragraph: ({ children }) => (
                    <p className="p1 text-grey-400">{children}</p>
                ),
                listItem: ({ children }) => (
                    <ul className="list-disc pl-5 text-grey-400">
                        <li className="p1">{children}</li>
                    </ul>
                ),
                oListItem: ({ children }) => (
                    <li className="p1 ml-4">{children}</li>
                ),
                hyperlink: ({ children, node }) => (
                    <a
                        className="font-demi hover:underline"
                        href={node.data.url}
                    >
                        {children}
                    </a>
                ),
            }}
        />
    );
};

export default PrismicBodyText;
